import { isMobile, isNoNull, isQQ, isUserName, noZeroInteger, isEmail } from "@/views/zhiji/js/common/util.js";

let ruleData = {
    checkMobile: genCheckHandler(isMobile),
    checkNoNull: genCheckHandler(isNoNull),
    checkQQ: genCheckHandler(isQQ),
    checkNickName: genCheckHandler(isUserName),
    checkCount: genCheckHandler(noZeroInteger),
    checkEmail: genCheckHandler(isEmail)
};

function genCheckHandler(check) {
    return function(val, msg) {
        return !check(val) ? msg : "success";
    };
}

export function checkAll(rulesList, value) {
    if (!rulesList || !rulesList.length) {
        return;
    }

    let errorMsg = "";
    errorMsg = rulesList.map(item => {
        return ruleData[item.rule](value, item.msg);
    });

    let filterMsg = errorMsg.find(item => {
        return item !== "success";
    });

    let error = "";
    filterMsg === undefined ? (error = "success") : (error = filterMsg);

    return error;
}
